import $ from 'jquery';
import axios from 'axios';
import { setSlick } from '@/shared/slick';

// コンテンツを取得して反映します
const getContent = $element => {
    axios
        .request({
            method: 'get',
            url: $element.data('url'),
        })
        .then(response => {
            if (response.data) {
                $element.html(response.data);
                settingSlick();
            } else {
                $element.remove();
            }
        })
        .catch(err => {
            // ネットワークエラーとか then でのエラーとかの時
            $element.remove();
        });
};

// こだわりリンク カルーセル
export const settingSlick = (frameWidth = null) => {
    if ($('.slick_carousel').length <= 0) {
        return null;
    }
    const width = frameWidth ? frameWidth :window.innerWidth;
    if (width >= 767) {
        $('.slick_carousel.slick-initialized').slick('unslick');
    } else {
        setSlick($('.slick_carousel').not('.slick-initialized'), {
            dots: false,
            arrows: false,
            infinite: false,
            centerMode: true,
            slidesToShow: 1.12,
            centerPadding: '15px',
        });
    }
}

// こだわりリンクの各コンテンツを非同期で読み込みます
export const loadContents = () => {
    $('.kodawari_link').each((index, element) => {
        let $element = $(element);
        getContent($element);
    });
};

// 画面幅変更時カルーセル再設定
$(window).on('resize', e => {
    settingSlick();
});
